import React, { useEffect, useState } from 'react';
import { Device } from '../../types';
import { BottomSheet, PanelRow, SidePanel } from '../ui/SidePanel';
import { Field, NativeSelect, TextInput } from '../ui/Field';
import { deviceMakeOptions, planLabel } from '../../data/district';
import { studentById } from '../../data/students';
import { useToast } from '../../contexts/ToastContext';
interface DevicePanelProps {
  device: Device | null;
  onClose: () => void;
}
export function DevicePanel({
  device,
  onClose
}: DevicePanelProps) {
  const {
    showToast
  } = useToast();
  const [editing, setEditing] = useState(false);
  const [make, setMake] = useState('');
  const [model, setModel] = useState('');
  const [serial, setSerial] = useState('');
  const [assetTag, setAssetTag] = useState('');
  useEffect(() => {
    if (device) {
      setMake(device.make);
      setModel(device.model);
      setSerial(device.serialNumber);
      setAssetTag(device.assetTagId);
      setEditing(false);
    }
  }, [device]);
  if (!device) return null;
  const student = studentById(device.studentId);
  return <SidePanel open title={device.model} onClose={onClose} action={<button type="button" onClick={() => setEditing(true)} className="h-8 shrink-0 rounded border border-ink-300 px-3 text-[12.5px] font-medium text-ink-700 hover:bg-ink-50" data-id="element-227" data-mp="lgjovdnsqrpq">
          Edit Info
        </button>} sheet={editing ? <BottomSheet title="Edit Device Information" onCancel={() => setEditing(false)} onSave={() => {
    setEditing(false);
    showToast('Device Updated', 'Device information has been saved successfully');
  }} data-id="element-228" data-mp="ggx32ftwk35b">
            <Field label="Device Make" htmlFor="device-make" data-id="element-229" data-mp="3ox8o0el1uz5d">
              <NativeSelect id="device-make" value={make} onChange={setMake} options={deviceMakeOptions} placeholder="Enter Device Make" data-id="element-230" data-mp="3oxs3zpr53dgr" />
            </Field>
            <Field label="Device Model" htmlFor="device-model" data-id="element-231" data-mp="1uomry9xw7pkn">
              <TextInput id="device-model" value={model} onChange={setModel} placeholder="Enter Device Model" data-id="element-232" data-mp="1unbj3vplbrmo" />
            </Field>
            <Field label="Serial Number" htmlFor="device-serial" data-id="element-233" data-mp="1lozw03nxnbyz">
              <TextInput id="device-serial" value={serial} onChange={setSerial} placeholder="Enter Serial Number" data-id="element-234" data-mp="1lmn7f7no63cy" />
            </Field>
            <Field label="Asset Tag ID" htmlFor="device-asset" data-id="element-235" data-mp="2dfe5lnowy24u">
              <TextInput id="device-asset" value={assetTag} onChange={setAssetTag} placeholder="Enter Asset Tag ID" data-id="element-236" data-mp="2ddtd03m5st9m" />
            </Field>
          </BottomSheet> : null} data-id="element-226" data-mp="zfsy1tdl4lk7">
      <dl className="pt-1" data-id="element-237" data-mp="24h258ty8vpz7">
        <PanelRow label="Device Type" value={device.deviceType} data-id="element-238" data-mp="xym54gh33j5z" />
        <PanelRow label="Make" value={device.make} data-id="element-239" data-mp="xwstsnvj0arn" />
        <PanelRow label="Model" value={device.model} data-id="element-240" data-mp="szj6pevm0b6z" />
        <PanelRow label="Associated Plan" value={planLabel(device.planId)} data-id="element-241" data-mp="t25gll5z32sd" />
        <PanelRow label="Student Name" value={student ? student.name : 'No Student Assigned'} data-id="element-242" data-mp="34oz6x2px3ebb" />
        <PanelRow label="Student Email" value={student && student.email ? student.email : '-'} data-id="element-243" data-mp="39mquxlnfyga8" />
        {student && <PanelRow label="Student ID" value={student.studentId} data-id="element-244" data-mp="3dmja4h7cbkok" />}
        <PanelRow label="Serial Number" value={device.serialNumber} data-id="element-245" data-mp="3ifkqktn73sa9" />
        <PanelRow label="Asset Tag ID" value={device.assetTagId} data-id="element-246" data-mp="3ndw0139kw0ry" />
        <PanelRow label="Date Added" value={device.dateAdded} data-id="element-247" data-mp="3nfqd5velyolh" />
      </dl>
      <div className="mx-5 mt-3 border-t border-ink-200" data-id="element-248" data-mp="3sbfi6e9ecxp6" />
    </SidePanel>;
}